import React from 'react';
import { PropTypes } from 'prop-types';
import PersonalInfoItem from './PersonalInfoItem'
import DisplayFormatters from './DisplayFormatters'
//import Tag from '../../tag/Tag'
import './PersonalInfo.scss'

const PersonalInfoBlock = (props) => {
    var { profile, lang } = props;

    return (
        <div className="hrb-profile-personal-container">
            <PersonalInfoItem title='profile.personal_info.name' value={DisplayFormatters.formatName(profile)} />
            <PersonalInfoItem title='profile.personal_info.email' value={profile.email} />
            <PersonalInfoItem title='profile.personal_info.username' value={profile.userName} />
            <PersonalInfoItem title='profile.personal_info.mobile_phone' value={DisplayFormatters.formatPhone(profile)} />
            <PersonalInfoItem title='profile.personal_info.province' value={DisplayFormatters.formatProvince(profile, lang)} />
        </div>
    );
}

/*  TODO: Put this back once we're putting email verification back
 *             <PersonalInfoItem title='profile.personal_info.email' value={profile.email}>
                {profile.isVerified ? <Tag title='profile.personal_info.verified' tagLevel='ok' />
                    : <Tag title='profile.personal_info.unverified' tagLevel='warning' />}
            </PersonalInfoItem>
*/


PersonalInfoBlock.propTypes = {
    profile: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired
};

export default PersonalInfoBlock;